import list from './leadsAssigned'export default list